import CustomButton from "@Common/CustomButton"
import { HeaderWrapper } from "./styles"
import { useTranslation } from "react-i18next"

export default function Header() {
	const { t } = useTranslation()
	return (
		<HeaderWrapper>
			<div className='containerLabel'>
				<p>{t("UserManagement.addMember")}</p>
			</div>
			<div>
				<CustomButton
					label={t("UserManagement.add")}
					withBG
					customPadding='12px 24px'
					type='submit'
				/>
			</div>
		</HeaderWrapper>
	)
}
